import React, {useEffect} from "react";
import BannerImg from "../../assets/images/banner.png";
import Img2 from "../../assets/images/image-2.png";
import Img3 from "../../assets/images/image-3.png";
import Img4 from "../../assets/images/image-4.png";
import {Helmet} from "react-helmet";
import {FormRegister} from "./FormRegister";
import {useAppSelector} from "../../redux/hooks";
import {getVoucherThunk, selectGetVoucher, selectUserInfo} from "../../redux/slices/appSlice";
import {useDispatch} from "react-redux";
import {redirectAuth} from "../../common/RedirectAuth";
import {AppDispatch} from "../../redux/store";
import {getToken} from "../../common/Storage";
import {Voucher} from "./Voucher";
import {useSearchParams} from "react-router-dom";
import BetiaImg from "../../assets/images/betia.png";
import IcFacebook from "../../assets/images/icons/fb-ic.png";
import IcPhone from "../../assets/images/icons/phone-ic.png";
import QRZalo from "../../assets/images/qr-zalo.png";
import QRZaloBavi from "../../assets/images/qr-zalo-bavi.png";
import SeoImage from "../../assets/images/image-seo.jpg"

export const LandingPage: React.FC = () => {

    const dispatch: AppDispatch = useDispatch();
    const [searchParams] = useSearchParams();

    const selUserInfo = useAppSelector(selectUserInfo);
    const selGetVoucher = useAppSelector(selectGetVoucher);

    useEffect(() => {
        if (selUserInfo && searchParams.get("tel")) {
            fetchVoucher(searchParams.get("tel") as string)
        }
    }, [selUserInfo]);

    const handleOnSuccess = (tel: string) => {
        if (selUserInfo) {
            fetchVoucher(tel)
        } else {
            redirectAuth("login", window.location.href.replace(/\?.*$/, "") + "?tel=" + tel)
        }
    }
    const fetchVoucher = async (tel: string) => {
        const {payload} = await dispatch(getVoucherThunk({
            api_key: "string",
            tel: tel,
            serviceCode: process.env.REACT_APP_SERVICE_CODE as string,
            userId: 0,
            token: getToken() as string,
            IPClient: "string",
            deviceId: "string",
            sign: "string",
            deltatime: 0,
            redirectUrl: "string"
        }))
        if (payload?.code === 0) {
            document.querySelector("#voucher")?.scrollIntoView({behavior: "smooth"});
        }
    }

    const scrollToForm = () => {
        document.querySelector("form")?.scrollIntoView({behavior: "smooth", block: "center"});
    }

    return <>
        {/*@ts-ignore*/}
        <Helmet>
            <title>Cuộc thi Ngôi Sao Tiếng Anh</title>
            <meta property="title" content="Cuộc thi Ngôi Sao Tiếng Anh"/>
            <meta name="description"
                  content="Cuộc thi được tổ chức nhằm đáp ứng nhu cầu nâng cao năng lực tiếng Anh, đặc biệt là kỹ năng nói cho học sinh trên địa bàn huyện Ba Vì."/>
            <meta property="article:author" content="VTCOnline"/>
            <meta name="keywords" content=""/>
            <meta property="og:title" content="Cuộc thi Ngôi Sao Tiếng Anh"/>
            <meta property="og:url" content="https://edu.go.vn/ngoi-sao-tieng-anh-ba-vi"/>
            <meta property="og:type" content="website"/>
            <meta property="og:image" content={SeoImage}/>
            <meta property="og:description"
                  content="Cuộc thi được tổ chức nhằm đáp ứng nhu cầu nâng cao năng lực tiếng Anh, đặc biệt là kỹ năng nói cho học sinh trên địa bàn huyện Ba Vì."/>
        </Helmet>
        <div className={"pb-[.5rem]"}>
            <div className={"xl:max-w-[1200px] mx-auto px-[1rem]"}>
                <section className={"flex flex-col items-center py-[3.75rem]"}>
                    <h1 className={"text-[#105296] text-[2rem] font-bold text-center uppercase"}>Ngôi sao tiếng Anh</h1>
                    <img className={"mt-[1rem] max-h-[444px]"} src={BannerImg} alt=""/>
                </section>
                <section className={"text-[1.125rem] text-justify"}>
                    <b>Giới thiệu chung:</b><br/>
                    Thực hiện Đề án số 374/ĐA-UBND ngày 26/9/2024 về việc Hỗ trợ dạy học ngoại ngữ cho các trường tiểu học huyện
                    Ba Vì năm học 2024-2025 và những năm tiếp theo; Phòng Giáo dục và Đào tạo Ba Vì phối hợp cùng Ban Tổ chức Cuộc thi Olympic
                    Tiếng Anh trên Internet (IOE) triển khai Cuộc thi <b className={"text-[#C81E1E]"}>“Ngôi Sao Tiếng Anh Huyện Ba Vì”</b> năm học
                    2024-2025 nhằm đáp ứng nhu cầu nâng cao
                    năng lực tiếng Anh, đặc biệt là kỹ năng nói tiếng Anh cho học sinh trên địa bàn huyện Ba Vì. <br/><br/>
                    Tham gia cuộc thi là cơ hội để học sinh rèn luyện và nâng cao toàn diện các kỹ năng ngôn ngữ nghe, nói, đọc, viết đặc biệt là phát
                    triển kỹ năng nói với ứng dụng trí tuệ nhân tạo (AI), giúp học sinh tự tin giao tiếp tiếng Anh trong học tập và cuộc
                    sống. <br/><br/>
                    Để hỗ trợ và đồng hành cùng học sinh trong suốt kỳ thi, VTC Online cung cấp miễn phí phần mềm luyện nói tiếng Anh “Betia English”
                    như công cụ hỗ trợ hiệu quả để học sinh rèn luyện kỹ năng phát âm chuẩn, phản xạ nghe-nói tự tin giao tiếp tiếng Anh. Học sinh có
                    thể sử dụng tài khoản IOE để trải nghiệm phần mềm Betia English, đồng thời luyện tập liên tục nhằm chuẩn bị tốt nhất cho cuộc thi.<br/>
                    <b>Học sinh nhận mã trải nghiệm Betia English</b> <span className={"underline cursor-pointer font-bold text-[#C81E1E]"}
                                                                            onClick={scrollToForm}>tại đây!</span>
                    <br/>
                </section>
                <section className={"mt-[5rem]"}>
                    <h2 className={"text-[2rem] font-bold text-center text-[#105296]"}>CÁC VÒNG THI</h2>
                    <ul className={"bg-white rounded-[2.5rem] px-[1.5rem] xl:px-[6.3rem] mt-[1rem]"}>
                        <li className={"py-[3.75rem] flex flex-col xl:flex-row gap-[1.24rem] xl:items-center"} id={"round-1"}>
                            <ul className={"xl:flex-1"}>
                                <li className={"text-[#1A82B3] text-[1.25rem] font-bold"}>ROUND 1<br/>TỰ LUYỆN</li>
                                <li className={"text-[#1A82B3]"}>Hoàn thành 5 Vòng thi</li>
                                <li className={"pt-[1.25rem]"}>
                                    <b>Cách thức tham gia:</b> Học sinh sử dụng tài khoản IOE và chủ động tham gia tự luyện trong thời gian hệ thống
                                    mở theo từng vòng
                                </li>
                                <li className={""}>
                                    <b>Tham gia thi ngày: </b>12/02/2025 - 16/03/2025
                                </li>
                            </ul>
                            <div className={"xl:flex-1 relative cursor-pointer group"}>
                                <div className={"card flex flex-col items-center"}>
                                    <div className={"relative rounded-[1rem] overflow-hidden"}>
                                        <img src={Img2} alt=""/>
                                        <div
                                            className={"opacity-0 absolute inset-0 bg-black rounded-[1rem] transition-opacity" +
                                                " duration-300"}/>
                                    </div>
                                    {/*<div
                                        className={"action absolute bottom-[4rem] xl:opacity-0 group-hover:opacity-100 transition-opacity duration-300"}>
                                        <button className={"flex items-center gap-[.5rem] bg-[#F24B18] text-white font-bold p-[1.25rem]" +
                                            " rounded-[1rem]" +
                                            " cursor-pointer"} onClick={() => navigate(ROUTER_PATHS.ROUND1)}>
                                            Xem chi tiết <FaArrowRight/>
                                        </button>
                                    </div>*/}
                                </div>
                            </div>
                        </li>

                        <li className={"py-[3.75rem] flex flex-col xl:flex-row gap-[1.24rem] xl:items-center border-t-[1px] border-solid" +
                            " border-[#D9D9D9]"} id={"round-2"}>
                            <ul className={"xl:flex-1"}>
                                <li className={"text-[#1A82B3] text-[1.25rem] font-bold"}>ROUND 2<br/>THI CẤP TRƯỜNG</li>
                                <li className={"pt-[1.25rem]"}><b>Cách thức tham gia:</b> Giáo viên quản trị trường đăng ký trực tuyến danh sách học
                                    sinh dự thi từ 09h00 ngày 17/3/2025 đến 17h30 ngày 23/03/2025
                                </li>
                                <li>
                                    <b>Thời gian dự kiến thi:</b> 26/03/2025 - 28/03/2025
                                </li>
                            </ul>
                            <div className={"xl:flex-1 relative cursor-pointer group"}>
                                <div className={"card flex flex-col items-center"}>
                                    <div className={"relative rounded-[1rem] overflow-hidden"}>
                                        <img src={Img3} alt=""/>
                                        <div
                                            className={"opacity-0 absolute inset-0 bg-black rounded-[1rem] transition-opacity" +
                                                " duration-300"}/>
                                    </div>
                                    {/*<div
                                        className={"action absolute bottom-[4rem] xl:opacity-0 group-hover:opacity-100 transition-opacity duration-300"}>
                                        <button className={"flex items-center gap-[.5rem] bg-[#F24B18] text-white font-bold p-[1.25rem]" +
                                            " rounded-[1rem]" +
                                            " cursor-pointer"} onClick={() => navigate(ROUTER_PATHS.ROUND2)}>
                                            Xem chi tiết <FaArrowRight/>
                                        </button>
                                    </div>*/}
                                </div>
                            </div>
                        </li>

                        <li className={"py-[3.75rem] flex flex-col xl:flex-row gap-[1.24rem] xl:items-center border-t-[1px] border-solid" +
                            " border-[#D9D9D9]"} id={"round-3"}>
                            <ul className={"xl:flex-1"}>
                                <li className={"text-[#1A82B3] text-[1.25rem] font-bold"}>ROUND 3<br/>THI CẤP HUYỆN</li>
                                <li className={"pt-[1.25rem]"}><b>Cách thức tham gia:</b> Giáo viên quản trị trường đăng ký trực tuyến danh sách học
                                    sinh dự thi từ 09h00 ngày 31/3/2025 đến 17h30 ngày 06/04/2025
                                </li>
                                <li className={""}>
                                    <b>Thời gian dự kiến thi:</b> 11/04/2025
                                </li>
                            </ul>
                            <div className={"xl:flex-1 relative cursor-pointer group"}>
                                <div className={"card flex flex-col items-center"}>
                                    <div className={"relative rounded-[1rem] overflow-hidden"}>
                                        <img src={Img4} alt=""/>
                                        <div
                                            className={"opacity-0 absolute inset-0 bg-black rounded-[1rem] transition-opacity" +
                                                " duration-300"}/>
                                    </div>
                                    {/*<div
                                        className={"action absolute bottom-[4rem] xl:opacity-0 group-hover:opacity-100 transition-opacity duration-300"}>
                                        <button className={"flex items-center gap-[.5rem] bg-[#F24B18] text-white font-bold p-[1.25rem]" +
                                            " rounded-[1rem] cursor-pointer"}
                                                onClick={() => navigate(ROUTER_PATHS.ROUND3)}>
                                            Xem chi tiết <FaArrowRight/>
                                        </button>
                                    </div>*/}
                                </div>
                            </div>
                        </li>
                    </ul>
                </section>
            </div>
            <section className={"mt-[50px] relative xl:min-h-[660px]"}>
                <div className={"xl:max-w-[1200px] mx-auto p-[1rem] xl:p-[60px]"}>
                    <h4 className={"font-bold text-[2rem] text-[#105296] text-center"}>PHẦN MỀM HỖ TRỢ</h4>
                    <div className={"xl:absolute bottom-[-116px] left-0 right-0"}>
                        <div className={"xl:max-w-[1200px] mx-auto flex flex-col xl:flex-row xl:gap-[24px]"}>
                            <div className={"pt-[63px] xl:flex-1"}>
                                <p className={"text-[#252525] text-justify"}>Để rèn luyện kỹ năng phát âm chuẩn, phản xạ nghe-nói tiếng Anh,
                                    và trang bị các mẫu câu giao tiếp, học sinh truy cập ứng dụng
                                    Betia English. Với phương pháp luyện nói theo cụm từ Chunking,
                                    và trải nghiệm giao tiếp nhập vai game hóa, Betia English giúp học sinh
                                    chuẩn bị kỹ năng vững chắc cho cuộc thi Ngôi sao tiếng Anh.
                                    (Học sinh truy cập vào ứng dụng sử dụng tài khoản IOE)</p>
                                <div className={"flex flex-col xl:flex-row items-center gap-4 mt-4"}>
                                    <div className={"xl:flex-1"}>
                                        {/*<QRCodeCanvas size={203}*/}
                                        {/*              value={"https://betia.go.vn/events/install-app/download?name=betia1"}/>*/}
                                        <img src={QRZalo} className={"max-h-[205px]"} alt=""/>
                                    </div>
                                    <div className={"xl:flex-2"}>
                                        <img src={BetiaImg} className={"max-w-[329px]"} alt=""/>
                                    </div>
                                </div>
                            </div>
                            <div className={"xl:max-w-[384px] xl:min-h-[553px] flex-1"}>
                                {selGetVoucher ? <Voucher/> : <div className={"relative group"}>
                                    <FormRegister onSuccess={handleOnSuccess}/>
                                    {!selUserInfo && <div className={"absolute inset-0 w-full h-full flex-col justify-center items-center" +
                                        " bg-[#000000] bg-opacity-70 rounded-[24px] hidden group-hover:flex"}>
                                        <button className={"mx-[1rem] xl:mx-0 bg-[#F24B18] font-bold text-white px-[1.25rem] py-[.725rem]" +
                                            " rounded-[.725rem]"}
                                                onClick={() => redirectAuth(
                                                    "login",
                                                    window.location.href.replace(/\?.*$/, "")
                                                )}>Tham gia cuộc thi
                                        </button>
                                    </div>}
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className={"xl:max-w-[1200px] mx-auto px-[1rem]"}>
                <section className={"xl:mt-[180px] guide-install pt-[40px] pb-[80px]"}>
                    <h4 className={"text-[#105296] font-bold text-[32px] text-center uppercase"}>Các kênh hỗ trợ</h4>
                    <div className={"mt-4 xl:w-[1150px] py-[40px] px-4 xl:px-[80px] xl:mx-auto xl:max-w-[1200px] rounded-[30px] bg-white"}>
                        <ul className={"flex flex-col justify-center xl:flex-row gap-[30px] text-white text-[14px] font-bold"}>
                            <li className={"flex-1 justify-center bg-[#0095DA] rounded-[30px] py-4"}>
                                <div className={"flex gap-4 items-center py-4 px-8"}>
                                    <div className={"flex justify-center"}>
                                        <img src={QRZaloBavi} className={"max-w-[150px]"} alt=""/>
                                    </div>
                                    <a href={"https://zalo.me/g/hqfboc181"}
                                       className={"flex items-center justify-center h-[54px] gap-4 italic text-[14px]"}>
                                        {/*<img src={IcZalo} className={"max-h-[30px]"} alt=""/>*/}
                                        Kênh zalo hỗ trợ cuộc thi <br/>Nhóm zalo: Ngôi Sao TA_PGD Ba Vì
                                    </a>
                                </div>
                            </li>
                            <li className={"flex-1 bg-[#0095DA] flex flex-col justify-center items-start rounded-[30px] py-4"}>
                                <div className={"flex items-center justify-center gap-4 pl-[2rem]"}>
                                    <img src={IcFacebook} className={"max-w-[30px]"} alt=""/>
                                    <a href="https://www.facebook.com/ioe.vn/">Fanpage: https://www.facebook.com/ioe.vn/</a>
                                </div>
                                <div className={"flex items-center justify-center gap-4 pl-[2rem] mt-2"}>
                                    <img src={IcPhone} className={"max-w-[30px]"} alt=""/>
                                    <a href="tel:1900636876">Tổng đài: 1900.636.876 (hoạt động: 08h30-21h00 T2-T6)</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </section>
                {/*<section className={"pb-[3rem]"}>
                    <div>
                        <h3 className={"text-[2rem] uppercase text-[#105296] font-bold text-center"}>Ban tổ chức & ban giám khảo</h3>
                        <div className={"py-[2.5rem] bg-white rounded-[2rem] mt-[1.5rem]"}>
                            <ul className={"xl:max-w-[996px] mx-auto flex gap-[1.5rem] flex-col xl:flex-row items-center xl:items-end"}>
                                <li className={"flex-1 flex flex-col items-center"}>
                                    <img src={DoanIcon} className={'w-[205px]'} alt=""/>
                                    <h4 className={"text-[#252525] font-bold text-[1.25rem] uppercase pt-[1.5rem]"}>Ban tổ chức</h4>
                                </li>
                                <li className={"flex-1 flex flex-col items-center"}>
                                    <img className={"max-w-[207px]"} src={CsdcIcon} alt=""/>
                                    <h4 className={"text-[#252525] font-bold text-[1.25rem] uppercase pt-[1.5rem]"}>Đơn vị tổ chức</h4>
                                </li>
                                <li className={"flex-1 flex flex-col items-center"}>
                                    <img src={VtcIcon} alt=""/>
                                    <h4 className={"text-[#252525] font-bold text-[1.25rem] uppercase pt-[1.5rem]"}>Đơn vị tổ chức</h4>
                                </li>
                            </ul>
                            <p className={"pt-[2.5rem] font-bold text-center"}>Ban Tổ chức sẽ thành lập Ban Giám khảo của từng vòng bao gồm: Đại
                                diện
                                Ban Tổ chức chương
                                trình và đội ngũ chuyên gia về tiếng Anh.</p>
                        </div>
                    </div>
                </section>*/}
            </div>
        </div>
    </>
}
